<ng-container *transloco="let t">
  <div class="dialogContainer">
    <p-progressSpinner></p-progressSpinner>
    <p>{{ t('apk.summaryForm.signPolicyDialog.loading') }}</p>
  </div>
</ng-container>
